var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"illegalInfo"},[_c('h3'),_c('van-nav-bar',{attrs:{"title":"监播详情","left-text":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.$router.push('/home')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }